var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.record)?_c(_vm.componentItem,_vm._b({tag:"component",on:{"hook:mounted":_vm.childMounted}},'component',_vm.getComponentProps,false)):_c('a-form-item',{style:(_vm.formConfig.layout === 'horizontal' &&
   _vm.formConfig.labelLayout === 'flex' &&
   _vm.isShowLabel(_vm.record.options.showLabel)
     ? { display: 'flex' }
     : {}),attrs:{"wrapper-col":_vm.formConfig.layout === 'horizontal' &&
   _vm.isShowLabel(_vm.record.options.showLabel)
     ? _vm.formConfig.labelLayout === 'flex'
       ? { style: 'width:auto;flex:1' }
       : _vm.formConfig.wrapperCol
     : {}}},[_c('span',{domProps:{"textContent":_vm._s(_vm.record.componentName)}}),_c(_vm.componentItem,_vm._b({directives:[{name:"decorator",rawName:"v-decorator",value:([
       _vm.record.model, // input 的 name
       {
         initialValue: _vm.record.options.defaultValue || '请在控件设置输入默认值', // 默认值
         valuePropName: _vm.record.type === 'switch' ? 'checked' : 'value',
         rules: _vm.record.rules // 验证规则
       }
     ]),expression:"[\n       record.model, // input 的 name\n       {\n         initialValue: record.options.defaultValue || '请在控件设置输入默认值', // 默认值\n         valuePropName: record.type === 'switch' ? 'checked' : 'value',\n         rules: record.rules // 验证规则\n       }\n     ]"}],ref:"inputItem",tag:"component",on:{"hook:mounted":_vm.childMounted,"change":_vm.handleChange}},'component',_vm.getComponentProps,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }